export const HeroContent = ({ title, paragraph, onDonateClick }) => {
  return (
    <div className="col-md-8 col-md-offset-2 intro-text">
      <h1>
        {title || 'Loading'}
        <span></span>
      </h1>
      <p>{paragraph || 'Loading'}</p>
      <button onClick={onDonateClick} className="btn btn-custom btn-lg header-donate-btn">
        Donate Now
      </button>
    </div>
  );
};
